import { render, staticRenderFns } from "./TextLinks.vue?vue&type=template&id=02517b8d"
import script from "./TextLinks.vue?vue&type=script&lang=ts"
export * from "./TextLinks.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports